import { createSlice } from "@reduxjs/toolkit";
import { getcommission } from "../Action/Commission";

const CommissionSlice = createSlice({
  name: "Commission",
  initialState: {
    commission: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getcommission.fulfilled, (state, action) => {
      state.commission = action.payload;
    });
  },
});

export default CommissionSlice.reducer;
